import _ from 'lodash';
import { action, computed, IObservableArray, makeObservable, observable, runInAction, when } from 'mobx';
import moment from 'moment';
import { AdminImportsStore, AupFile, ImportDataType, ImportJobModel, ImportJobStatus } from '../admin.imports.store';
import { DatenStandModel, AdminDatenStandStore } from '../datenstand.store';
import { notify } from 'app/components/common/notify';

class JobFilter {
	constructor() {
		makeObservable(this);
	}

	@observable
	status?: ImportDataType;

	@action
	reset() {
		this.status = undefined;
	}
}

export class ImportJobVM {
	constructor(job: ImportJobModel) {
		this.job = job;
	}
	job: ImportJobModel;
	datenStand?: DatenStandModel;

	@computed
	get KW() {
		if (this.job.meta && this.job.meta.kw) {
			return this.job.meta.kw;
		}
		// if ((this.job.dataType === ImportDataType.aup || this.job.dataType === ImportDataType.crawler || this.job.dataType === ImportDataType.multisgp) && this.job.meta) {
		// 	return this.job.meta.kw;
		// }
		return;
	}


	@computed
	get kwFormated() {
		if (!this.KW) {
			return;
		}
		if ((this.job.dataType === ImportDataType.aup || this.job.dataType === ImportDataType.crawler) && this.job.meta) {
			return this.KW + ' (KW)';
		}
		return this.KW + ' (BM)';
	}

	@computed
	get fehler() {
		if (this.job.message) {
			return JSON.stringify(this.job.message, null, 2);
		}
		if (this.job.hasError2) {

			return this.job.message;
		}
	}
}

export class AdminImportsUiStore {
	adminImportsStore: AdminImportsStore;
	datenstandStore: AdminDatenStandStore;

	constructor(adminImportsStore: AdminImportsStore, datenstandStore: AdminDatenStandStore) {
		makeObservable(this);
		this.adminImportsStore = adminImportsStore;
		this.datenstandStore = datenstandStore;

		when(
			() => this.autoRefreshEnabled === true,
			async () => {
				do {
					await new Promise((resolve) => {
						setTimeout(() => {
							resolve(undefined);
						}, 2500);
					});
					console.log('refreshing');
					await this.reload();

					if (this.current) {
						runInAction(() => {
							this.current = this._items.find((i) => i.job.id === this.current!.job.id);
						});
					}
				} while (this.autoRefreshEnabled);
				return this.autoRefreshEnabled;
			},
		);
	}

	@observable current?: ImportJobVM;

	@observable
	currentFilter: JobFilter = new JobFilter();

	@computed
	get currentItems() {
		let items = this._items.map((i) => i);
		const f = this.currentFilter;
		if (!f) {
			return items;
		}

		return _.sortBy(items, (r) => r.job.created).reverse();
	}

	_items: IObservableArray<ImportJobVM> = observable([]);
	loaded: boolean = false;
	async load() {
		if (this.loaded) {
			return this._items;
		}

		const items = await this.adminImportsStore.findAll();
		const datenStaende = await this.datenstandStore.findAll();

		let res: ImportJobVM[] = [];

		items.forEach((t) => {
			const vm = new ImportJobVM(t);
			res.push(vm);
		});

		res = _.sortBy(res, i => i.job.created).reverse();


		datenStaende.forEach(d => {
			let dataType = d.dataType;
			if (dataType === 'aup_gp') {
				dataType = 'aup';
				const j = res.find(i => i.job.dataType === dataType);
				if (j) {
					j.datenStand = d;
				}

			} else {
				const j = res.find(i => i.job.dataType === dataType && i.job.meta.fileName === d.file);
				if (j) {
					j.datenStand = d;
				}
			}

		})


		runInAction(() => {
			this._items.replace(res);
			this.loaded = true;
		});

		return this._items;
	}

	@action
	async loadById(id?: string) {
		if (!id) {
			this.current = undefined;
		}
		const jobs = await this.findAll();
		const u = jobs.find((u) => u.job.id === id);
		runInAction(() => {
			this.current = u;
			this.newJob = undefined;
		});
	}

	@action
	createNewJob(dataType: ImportDataType) {
		const job = new ImportJobModel({
			created: new Date(),
			dataType: dataType,
			duration: -1,
			status: ImportJobStatus.new,
		});


		switch (dataType) {
			case ImportDataType.fitnesspdf:
				job.meta = {
					datenStand: new Date().toISOString(),
				};
				break;

			case ImportDataType.aup:
			case ImportDataType.aupvorjahr:
			case ImportDataType.crawler:
			case ImportDataType.crawlerMultigp25:
				job.meta = {
					kw: moment().format('YYYYww'),
				};
				break;

			default:
				//nothing todo 
				break;
		}


		this.current = undefined;
		this.newJob = new ImportJobVM(job);
	}




	@observable newJob?: ImportJobVM;

	@action
	async reload() {
		this.loaded = false;
		await this.load();
	}

	async getAupKwFiles(kw: string, lastChange?: Date) {
		let res = await this.adminImportsStore.getAupKwFiles(kw);
		if (res) {
			res = res.filter((f: AupFile) => f.fileName.toLowerCase().endsWith('.csv'));
		}
		return res;
	}

	async getAupVorjahrFiles(vorjahr: string, lastChange?: Date) {
		const res = await this.adminImportsStore.getAupVorjahrFiles(vorjahr);
		return res;
	}

	async getFilesByType(t: ImportDataType) {
		return this.adminImportsStore.getImportFilesForDataType(t);
	}

	async triggerJob(job: ImportJobModel) {
		notify('Job wird gestartet', '', 'info');
		const res = await this.adminImportsStore.triggerImportJob(job);
		return new Promise((resolve) => {
			setTimeout(() => {
				this.reload().then(() => {
					resolve(res);
				});
			}, 1000);
		});
	}

	async crawlOne(bensl: string, kw: string, forceSend: string) {
		const res = await this.adminImportsStore.crawlOne(bensl, kw, forceSend);
		return res;
	}

	@observable
	autoRefreshEnabled: boolean = false;

	@action
	toggleAutoRefresh() {
		this.autoRefreshEnabled = !this.autoRefreshEnabled;
	}

	async findAll() {
		return this.load();
	}
}
